import {
  ListItem as ListItemMui,
  List as ListMui,
  Link as LinkMui,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const List = styled(ListMui)`
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
`;

export const ListItem = styled(ListItemMui)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 16px;
  align-items: center;
  width: 100%;
`;

export const ListItemNoData = styled(ListItemMui)`
  display: flex;
  justify-content: center;
  padding: 16px;
  align-items: center;
  width: 100%;
`;

export const LeftItems = styled('div')`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 16px;
`;

export const CallData = styled('div')`
  width: 200px;
`;

export const Link = styled(LinkMui)(({ theme }) => ({
  color: 'unset',
  textDecoration: 'none',
  fontWeight: 'inherit',
  '&:hover': {
    color: 'unset',
    textDecoration: 'none',
    background: alpha(theme.palette.common.black, 0.06),
  },
  '*': {
    textDecoration: 'none',
  },
  width: '100%',
}));

export const TypographyEllipsis = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
